import PropTypes from 'prop-types';
import { omit } from 'ramda';
import classNames from 'classnames';
const Checkbox = ({
  id,
  isChecked = false,
  isDisabled,
  isAccented,
  onChange,
  text,
  hasHtmlTitle = false,
  children,
  baseClassName = 'checkbox checkbox-primary verify-panel__checkbox',
  iconClassName = 'verify-panel__checkbox-icon',
  ...props
}) => {
  const uniq = Math.random().toString(16).slice(2);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(baseClassName, {
      disabled: isDisabled,
      accented: isAccented
    }),
    ...omit(['onModalOpen', 'isMobileFieldWrapper', 'valid'], props)
  }, /*#__PURE__*/React.createElement("input", {
    checked: isChecked,
    onChange: e => isDisabled || onChange(e.target.checked),
    type: "checkbox",
    id: id || `checkbox-${uniq}`,
    disabled: isDisabled
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id || `checkbox-${uniq}`
  }, /*#__PURE__*/React.createElement("i", {
    className: iconClassName
  }), hasHtmlTitle ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }) : text), children);
};
Checkbox.propTypes = {
  id: PropTypes.string,
  children: PropTypes.element,
  isChecked: PropTypes.bool,
  isAccented: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hasHtmlTitle: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  baseClassName: PropTypes.string,
  iconClassName: PropTypes.string
};
export default Checkbox;